module.exports = __webpack_public_path__ + "static/media/canvas-builder-poster.6b26df9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/posterImgs/canvas-builder-poster.jpg
// module id = 415
// module chunks = 0